import { useEffect, useState } from 'react';

/**
 * A ticking "now" (epoch ms) for live turnaround clocks. Re-renders the subscriber on each interval
 * so an arrival-to-now age advances on screen without a data refetch. Default 1s (the header clock
 * shows seconds; the per-row minute display simply re-derives from the same value).
 */
export function useNow(intervalMs = 1_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
